import React from "react";
import { useTranslation } from "react-i18next";
import TestimonialCard from "./TestimonialCard";
import "./Testimonials.css";
import testimonial1Image from "../assets/image/TestimonialCard1.png";
import testimonial2Image from "../assets/image/TestimonialCard2.png";
import testimonial3Image from "../assets/image/TestimonialCard3.jpg";

const Testimonials: React.FC = () => {
  const { t, i18n } = useTranslation();

  return (
    <section className="testimonials-section">
      <div className="testimonials-content">
        <h1 className="testimonials-title">{t("testimonials")}</h1>
        <h2 className="testimonials-subtitle">{t("testimonialsSubtitle")}</h2>
        <p className="testimonials-description">
          {t("testimonialsDescription")}
        </p>

        <div className="testimonials-grid" data-language={i18n.language}>
          <TestimonialCard
            name={t("testimonial1.name")}
            text={t("testimonial1.text")}
            imageSrc={testimonial1Image}
            imageAlt="מקסים ויוליה יאכנין"
            rating={5}
          />

          <TestimonialCard
            name={t("testimonial2.name")}
            text={t("testimonial2.text")}
            imageSrc={testimonial2Image}
            imageAlt="שטיבל טחנות קמח"
            rating={5}
          />

          <TestimonialCard
            name={t("testimonial3.name")}
            text={t("testimonial3.text")}
            imageSrc={testimonial3Image}
            imageAlt="קרין גורן"
            rating={5}
          />
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
